<template>
    <div id="preview">
        <headers :title="titles"></headers>
        <noResouse v-if='noResouse'></noResouse>
        <div v-if="loading">
            <div class="itemLength"
                 v-if="type==1">共{{allquestion}}题</div>
            <div class="questions">
                <div class="question"
                     v-for="(item,qindex) in questions">
                    <i class="dge"
                       v-if='item.is_send && !isWrong'></i> <!--  发布标识 0 代表没有发过   1 发过 -->
                    <div class="quest_title"
                         v-if="item.subject.content||item.subject.image">
                        <!-- <span>{{qindex+1}}、</span> -->
                        <span v-if="item.subject.content!=''"
                              v-html='item.subject.content'></span>
                        <img :src="img"
                             v-for="img in item.subject.images"
                             v-if="item.subject.images.length">
                    </div>
                    <div v-if="item.listen_audio &&item.listen_audio!=''"
                         class="audio">
                        <div class="audio_warrp clearfix">
                            <div class="play_pause">
                                <img :id="'isplay'+item.id"
                                     src="./img/icon_start.png"
                                     alt=""
                                     v-show="!item.hearing"
                                     @click="start(item,qindex)">
                                <img :id="'pause'+item.id"
                                     v-show="item.hearing"
                                     src="./img/icon_suspend.png"
                                     alt=""
                                     @click="pause(item,qindex)">
                            </div>
                            <div class="audio_all"
                                 :id="'audio_all'+item.id">
                                <div class="audio_now"
                                     :id="'audio_now'+item.id"></div>
                            </div>
                        </div>
                        <!-- <Audio :ado="item" :sid="sid"></Audio> -->

                    </div>
                    <div v-for="ask,inx in item.asks">
                        <!-- 小题题目 -->
                        <div class="quest_title"
                             v-if="item.asks.length>1 ||(ask.subject.content ||ask.subject.images.length) && ask.subject.content!=item.subject.content && item.type!=10 ">
                            <span v-if="item.asks.length>1">({{inx+1}})</span>
                            <span v-if="ask.subject.content!=''"
                                  v-html="$options.filters.strReplace(ask.subject.content,'\#\#','或')"></span>
                            <img :src="askImg"
                                 v-for="askImg in ask.subject.images"
                                 v-if="ask.subject.images.length">
                        </div>

                        <div v-if="ask.listen_audio && ask.listen_audio!=''"
                             class="audio">
                            <div class="audio_warrp clearfix">
                                <div class="play_pause">
                                    <img :id="'isplay'+ask.id"
                                         src="./img/icon_start.png"
                                         alt=""
                                         v-show="!ask.hearing"
                                         @click="start(ask,qindex,inx)">
                                    <img :id="'pause'+ask.id"
                                         v-show="ask.hearing"
                                         src="./img/icon_suspend.png"
                                         alt=""
                                         @click="pause(ask,qindex,inx)">
                                </div>
                                <div class="audio_all"
                                     :id="'audio_all'+ask.id">
                                    <div class="audio_now"
                                         :id="'audio_now'+ask.id"></div>
                                </div>
                            </div>
                            <!-- <Audio :ado="ask" :sid="sid"></Audio> -->
                        </div>
                        <div v-if="sid==91">
                            <!-- 选择题 -->
                            <div class="choose"
                                 v-if="(item.type==1 || item.type==3 || item.type==4 || item.type==5 || item.type==6 || item.type==7 || item.type==8)">
                                <choice :list='ask'
                                        :askLength='item.asks.length'
                                        :isAudio="ask.listen_audio"></choice>
                            </div>
                            <!-- 填空 -->
                            <div v-if='ask.display_type == 2'>
                                <blanks :question='ask'
                                        :askLength='item.asks.length'></blanks>
                            </div>
                            <!-- 连词成句 -->
                            <div v-if='item.type==10'>
                                <div class="mark">
                                    <span class="mark_answer"
                                          v-for="an in ask.answer">{{an}}</span>
                                </div>
                            </div>
                            <!-- 连句成段 -->
                            <div v-if='item.type==11'>
                                <div class="mark_line">
                                    <p class="mark_answer"
                                       v-for="an in ask.answer">{{an}}</p>
                                </div>
                            </div>
                            <!-- 连线题 -->
                            <div class="line"
                                 v-if="item.type==2 && sid==91">
                                <line-component :ask='ask'
                                                :sheet="ask.answer"
                                                :onlyshow='true'
                                                :askLength='item.asks.length'></line-component>
                            </div>
                        </div>
                        <div class="choose"
                             v-if="sid==92">
                            <choice :list='ask'
                                    :askLength='item.asks.length'
                                    :isAudio="''"></choice>
                        </div>
                    </div>
                    <div class="ask_bottom clearfix">
                        <span class="wrong_rate"
                              v-if="isWrong==1">错误率：{{item.list.ratio}}%</span>
                        <span class="wrong_rate"
                              v-else>使用次数： {{item.send_num}}次</span>
                        <span class="dele"
                              v-if="type!=0 && item.choose"
                              @click="dele(item,qindex)">移除</span>
                        <span class="join"
                              v-if="type!=0 && !item.choose"
                              @click="join(item,qindex)">加入</span>
                    </div>
                </div>
            </div>
            <div class="bottom_btn clearfix"
                 v-if="type==1 && !noResouse">
                <div class="left_btn"><i></i><span>已选（{{totalNum}}题）</span></div>
                <div v-if='totalNum==0'
                     :class="['right_btn',{'able':totalNum>0,'disable':totalNum==0}]">去发布</div>
                <div v-else
                     :class="['right_btn',{'able':totalNum>0,'disable':totalNum==0}]"
                     @click='send'>去发布</div>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import line from 'VIEWS/english/module/tea/line.vue';
import choice from 'VIEWS/english/module/tea/choose.vue'; //选择题
import Audio from 'VIEWS/english/module/tea/audio.vue';  //填空题
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';

export default {
    data () {
        return {
            titles: '',
            type: this.$route.params.type,//0单个预览，1全部预览
            id: this.$route.query.id,
            title: this.$route.query.title || false,
            // sid:this.$route.query.sid, //2同步习题 3单元复习
            questions: [],
            loading: false,
            sid: this.$route.params.sid,
            noResouse: false,
            totalNum: 0,  //总题
            // qus_id:[],   //发布需要一个cid
            selectData: [],//所选题目
            isWrong: this.$route.query.wrong || 0,

            isfinish: true, //是否在暂停状态
            Speed: 1,
            proBar: null,  //原生定时器,
            listen_audio: null,
            listen_url: [],
            allquestion: 0,
            isHD_schoolopen: this.$route.query.schoolopen || 0,//开学大检查活动
        }
    },
    async created () {
        if (this.title) {
            this.titles = this.title;
        } else {
            this.titles = '习题预览';
        }
        // //console.log(this.qids)
        if (this.qids.length == 0) {
            this.$router.go(-1);
            return false;
        }
        // let exerdata  = this.type == 0 ? this.screenid : this.id
        // let qids =
        // 全部预览 需要新的id
        await this.$http.post(API_URL_TASK_API + '/english/send/sync/list', {
            q_ids: this.qids.join(','),
            sid: this.sid
        }).then(res => {
            this.loading = true;
            if (res.data.response === 'ok') {
                if (res.data.data.length) {
                    this.questions = res.data.data;
                    this.questions.forEach((m, n) => {
                        m.hearing = false  //听力条
                        m.asks.forEach((l, i) => {
                            this.allquestion++
                            l.hearing = false  //听力条
                        })
                    })
                    if (this.isWrong) {
                        // //console.log('错题')
                        let map = new Map();

                        let _array = this.$store.state.english.taskQids;
                        _array.forEach(a => {
                            map[a.qid] = a
                        });
                        this.questions.forEach((q, index) => {
                            q.choose = true;
                            let obj = {
                                qid: q.id,
                                q_no: index + 1
                            };
                            this.totalNum += q.asks.length;
                            this.selectData.push(obj);
                            q.list = map[q.id];
                        })
                    }
                    if (this.type && !this.isWrong) {
                        this.questions.forEach((q, index) => {
                            q.choose = true;
                            let obj = {
                                qid: q.id,
                                q_no: index + 1
                            };
                            this.totalNum += q.asks.length;
                            this.selectData.push(obj);
                        })
                    }
                }
            }
            else {
                this.noResouse = true
            }
        })
    },
    computed: {
        qids () {
            if (this.isHD_schoolopen == 1) {//开学大检查活动
                let _qids = JSON.parse(localStorage.getItem('schoolopenQid'));
                return _qids.split(',');
            } else {
                if (this.isWrong == 1) {
                    let _array = this.$store.state.english.taskQids;
                    let _qids = [];
                    _array.forEach(a => {
                        // //console.log(a)
                        _qids.push(a.qid);
                    })
                    // //console.log(_qids)
                    return _qids
                } else {
                    if (this.type) {
                        // //console.log(this.$store.state.english.taskQids)
                        return this.$store.state.english.taskQids
                    }
                }
            }
        }
    },
    components: {
        headers,
        'line-component': line,
        loadingS,
        Audio,
        choice,
        noResouse,
    },
    methods: {
        start (source, index, inx, e) {
            if ((source.duration < 0 || source.duration == 0) && this.sid == 91) {
                source.duration = 1
            }

            if ((source.listen_duration < 0 || source.listen_duration == 0) && this.sid == 91) {
                source.listen_duration = 1
            }
            // 全部初始话为true
            this.questions.forEach((m, n) => {
                m.hearing = false
                m.asks.forEach((l, i) => {
                    l.hearing = false
                })
            })
            source.hearing = true
            if (this.sid == 91) {
                this.questions[index].asks.splice(inx, 1, source)
            } else {
                this.questions.splice(index, 1, source)
            }


            this.proBar && clearInterval(this.proBar);
            this.getListTimer && clearTimeout(this.getListTimer);
            let _this = this
            let audio_now = document.querySelectorAll('.audio_now')

            // 判定是否是同一个音频地址
            if (this.listen_audio != source.listen_audio) {
                this.listen_audio = source.listen_audio
                //console.log('不一样')
                _this.Speed = 0;
                _this.isfinish = true
                for (var i = 0; i < audio_now.length; i++) {
                    audio_now[i].style.width = '0%';
                }
            } else {
                //console.log('一样')
            }
            let audio_nowID = document.getElementById('audio_now' + source.id) //获取进度条的元素

            let duration = source.duration * 10 || source.listen_duration * 10
            this.proBar = setInterval(() => {
                audio_nowID.style.width = (_this.Speed++) + '%';
                _this.isfinish = false
                if (_this.Speed > 100) {
                    _this.Speed = 1
                    for (var i = 0; i < audio_now.length; i++) {
                        audio_now[i].style.width = '0%';
                    }
                    source.hearing = false
                    if (_this.sid == 91) {
                        _this.questions[index].asks.splice(inx, 1, source)
                    } else {
                        _this.questions.splice(index, 1, source)
                    }
                    _this.proBar && window.clearInterval(_this.proBar);
                    _this.isfinish = true
                }
            }, duration);

            try {
                if (this.isfinish) {
                    // 播放
                    // appobject.Interactive("ys_stop_audio");
                    // appobject.Interactive("ys_start_audio," + source.listen_audio);
                    this.appFunction("ys_stop_audio", "");
                    this.appFunction("ys_start_audio", source.listen_audio);
                } else {
                    // 继续播放
                    // appobject.Interactive("ys_goon_audio");
                    this.appFunction("ys_goon_audio", "");
                }
            } catch (e) {
                //console.log(22)
            }

            // 原生回调 回复样式
            window.playfinished = function () {
                _this.Speed = 1
                for (var i = 0; i < audio_now.length; i++) {
                    audio_now[i].style.width = '0%';
                }
                source.hearing = false
                if (_this.sid == 91) {
                    _this.questions[index].asks.splice(inx, 1, source)
                } else {
                    _this.questions.splice(index, 1, source)
                }
                _this.proBar && window.clearInterval(_this.proBar);
                _this.isfinish = true;
            }
        },
        pause (source, index, inx) {
            // try {
            //   appobject.Interactive('ys_pause_audio')
            // } catch (e) {
            //   // //console.log(e)
            // }
            this.appFunction("ys_pause_audio", "")
            source.hearing = false;
            if (this.sid == 91) {
                this.questions[index].asks.splice(inx, 1, source)
            } else {
                this.questions.splice(index, 1, source)
            }
            this.proBar && window.clearInterval(this.proBar);
        },

        dele (item, index) {
            this.totalNum -= item.asks.length;
            item.choose = !item.choose
            this.questions.splice(index, 1, item);
            let _index = this.selectData.findIndex(data => data.qid == item.id);
            this.selectData.splice(_index, 1);
        },
        join (item, index) {
            // if (this.totalNum >= 30) {
            //   layer.tips('已经超出30道题，不能再添加试题了')
            //   return false
            // }
            if (this.sid == 91) {
                if (this.totalNum > 50) {
                    layer.tips('已经超出50道题，不能再添加试题了');
                    return false
                }
            } else if (this.sid == 92) {
                if (this.totalNum > 100) {
                    layer.tips('已经超出100道题，不能再添加试题了');
                    return false
                }
            }
            this.totalNum += item.asks.length;
            item.choose = !item.choose
            this.questions.splice(index, 1, item);
            let obj = {
                qid: item.id,
                q_no: index + 1
            };
            this.selectData.push(obj);
        },
        send () {
            // if (this.totalNum > 30) {
            //   layer.tips('已经超出30道题，无法发布')
            //   return false
            // }
            if (this.sid == 91) {
                if (this.totalNum > 50) {
                    layer.tips('已经超出50道题，无法发布');
                    return false
                }
            } else if (this.sid == 92) {
                if (this.totalNum > 100) {
                    layer.tips('已经超出100道题，无法发布');
                    return false
                }
            }
            this.$store.commit('setSendData', this.selectData)
            if (this.isWrong == 1) {
                this.$router.push('/english/release/' + this.sid + '/2?wrong=1')
            } else {
                this.$router.push('/english/release/' + this.sid + '/2')
            }
        }
    },
    beforeDestroy () {
        this.proBar && window.clearInterval(this.proBar);
        // try{
        //   appobject.Interactive("ys_stop_audio");
        // }catch(e){

        // }
        this.appFunction("ys_stop_audio", "")
        localStorage.removeItem('schoolopenQid')
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#preview {
    padding-bottom: 100px / $ppr;
}
.line {
    padding-top: 20px / $ppr;
    background: #fff;
}
.question {
    margin-bottom: 25px / $ppr;
    position: relative;
    .dge {
        width: 100px / $ppr;
        height: 56px / $ppr;
        position: absolute;
        right: 0;
        top: 20px / $ppr;
        // margin-top:-28px/$ppr;
        z-index: 2;
        background: url("./img/icon_to.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
}

.quest_title {
    padding: 25px / $ppr;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    border-bottom: 1px / $ppr solid #e8e8e8;
    background: #fff;
    font-size: 30px / $ppr;
}

.itemLength {
    padding: 0.6rem;
    line-height: 1.2rem;
    background: #fff;
    margin-bottom: 25px / $ppr;
    font-size: 30px / $ppr;
    font-weight: bold;
}

.ask_bottom {
    line-height: 96px / $ppr;
    height: 96px / $ppr;
    background: #fff;
    padding: 0 25px / $ppr;
    .wrong_rate {
        color: #999;
        font-size: 24px / $ppr;
        float: left;
    }
    .dele {
        float: right;
        width: 122px / $ppr;
        line-height: 50px / $ppr;
        height: 48px / $ppr;
        border: 1px / $ppr solid #ff6600;
        color: #ff6600;
        margin-top: 21px / $ppr;
        font-size: 28px / $ppr;
        text-align: center;
        border-radius: 24px / $ppr;
    }
    .join {
        float: right;
        width: 122px / $ppr;
        line-height: 50px / $ppr;
        height: 48px / $ppr;
        border: 1px / $ppr solid #5e89ef;
        color: #5e89ef;
        margin-top: 21px / $ppr;
        font-size: 28px / $ppr;
        text-align: center;
        border-radius: 24px / $ppr;
    }
}

.line {
    background: #fff;
}

.bottom_btn {
    width: 100%;
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    font-size: 30px / $ppr;
    text-align: center;
    .left_btn {
        width: 70%;
        float: left;
        background: #f0f0f0;
        color: #333;
        position: relative;
        i {
            position: absolute;
            z-index: 1;
            top: 25px / $ppr;
            display: inline-block;
            width: 50px / $ppr;
            height: 42px / $ppr;
            background: url("./img/icon1.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
        span {
            display: inline-block;
            padding-left: 60px / $ppr;
        }
    }
    .right_btn {
        width: 30%;
        float: right;
    }
    .able {
        color: #fff;
        background: #5e89ef;
    }
    .disable {
        color: #999;
        background: #ccc;
    }
}

.mark {
    padding: 25px / $ppr 15px / $ppr;
    background: #fff;
    border-bottom: 1px / $ppr solid #e8e8e8;
    span {
        display: inline-block;
        color: #66cc22;
        border-bottom: 1px / $ppr solid #66cc22;
        margin: 0 20px / $ppr;
        line-height: 46px / $ppr;
        height: 46px / $ppr;
    }
}

.mark_line {
    padding: 25px / $ppr;
    background: #fff;
    border-bottom: 1px / $ppr solid #e8e8e8;
    p {
        // display:inline-block;
        color: #66cc22;
        border-bottom: 1px / $ppr solid #66cc22;
        margin: 0 20px / $ppr;
        line-height: 46px / $ppr;
        height: 46px / $ppr;
    }
}

.audio {
    .audio_warrp {
        position: relative;
        width: 100%;
        height: 96px / $ppr;
    }
    .audio_all {
        width: 560px / $ppr;
        height: 24px / $ppr;
        background-color: #c9c9c9;
        position: absolute;
        top: 50%;
        right: 60px / $ppr;
        margin-top: -12px / $ppr;
        border-radius: 12px / $ppr;
        overflow: hidden;
        .audio_now {
            width: 0%;
            height: 100%;
            background-color: #5e89ef;
            border-radius: 12px / $ppr;
        }
    }
    .play_pause {
        width: 54px / $ppr;
        height: 54px / $ppr;
        border-radius: 50%;
        position: absolute;
        top: 21px / $ppr;
        left: 25px / $ppr;
        img {
            width: 54px / $ppr;
            height: 54px / $ppr;
        }
    }
}
</style>
